import React from "react";
import { ProjectsConfig } from "../../config";
import ProjectsDesktop from "./Projects_Desktop";
import ProjectsMobile from "./Projects_Mobile";

const Projects = ({ lang, screen }) => {
  const { title, projects, tags } = ProjectsConfig(screen);

  return screen > 1380 ? (
    <ProjectsDesktop
      lang={lang}
      title={title}
      projects={projects}
      tags={tags}
    />
  ) : (
    <ProjectsMobile
      screen={screen}
      lang={lang}
      title={title}
      projects={projects}
      tags={tags}
    />
  );
};

export default Projects;
